import { z } from 'zod'

export const StylesSchema = z.object({}).optional()
